import PropTypes from 'prop-types'
import { useWindowActions } from '../../../../models/window'
import { useRef, useState } from 'react'

import c from './sheet-modal.module.scss'

const SheetModal = ({ classTrigger, children }) => {
    const { closeWindow } = useWindowActions()

    const [translateY, setTranslateY] = useState(0)
    const startY = useRef(0)
    const dragging = useRef(false)

    const handleDragStart = (e) => {
        dragging.current = true
        startY.current = e.touches ? e.touches[0].clientY : e.clientY
    }

    const handleDragMove = (e) => {
        if (!dragging.current) return
        const currentY = e.touches ? e.touches[0].clientY : e.clientY
        const diff = currentY - startY.current
        if (diff > 0) {
            setTranslateY(diff)
        }
    }

    const handleDragEnd = () => {
        if (!dragging.current) return
        dragging.current = false

        if (translateY > 50) {
            closeWindow()
        } else {
            // откат обратно
            setTranslateY(0)
        }
    }

    return (
        <div
            className={c.component}
            style={{
                transform: `translateY(${translateY}px)`,
                transition: dragging.current ? 'none' : 'transform 0.3s ease',
            }}
        >
            <div
                className={c.trigger}
                onMouseDown={handleDragStart}
                onMouseMove={handleDragMove}
                onMouseUp={handleDragEnd}
                onMouseLeave={handleDragEnd}
                onTouchStart={handleDragStart}
                onTouchMove={handleDragMove}
                onTouchEnd={handleDragEnd}
            />
            <div className={c.container}>{children}</div>
        </div>
    )
}

SheetModal.propTypes = {
    classTrigger: PropTypes.string,
}

export default SheetModal
